// Flow / pipe-sizing constants. Approximate inner diameter (mm) by nominal DN
// and the target flow velocity band for sizing. Editable approximations.

export type DnInner = { dn: number; innerMm: number };

export const DN_INNER: DnInner[] = [
  { dn: 20, innerMm: 20 },
  { dn: 25, innerMm: 25 },
  { dn: 32, innerMm: 32 },
  { dn: 40, innerMm: 40 },
  { dn: 50, innerMm: 50 },
  { dn: 63, innerMm: 60 },
  { dn: 75, innerMm: 73 },
  { dn: 90, innerMm: 79 },
];

// Good-practice velocity band (m/s) for closed-loop heating/cooling.
export const VELOCITY_MAX = 1.2;
export const VELOCITY_TARGET = 1.0;

/** Water volumetric flow (m³/h) for a heat duty. flow = kW / (1.163 · ΔT). */
export function flowM3h(kW: number, deltaT: number): number {
  if (deltaT <= 0) return 0;
  return kW / (1.163 * deltaT);
}

/** Flow velocity (m/s) in a pipe of given inner Ø (mm) for a flow (m³/h). */
export function velocity(flowM3hVal: number, innerMm: number): number {
  const area = Math.PI * Math.pow(innerMm / 1000 / 2, 2); // m²
  if (area <= 0) return 0;
  return flowM3hVal / 3600 / area;
}

/** Smallest DN whose velocity stays within VELOCITY_MAX (else the largest). */
export function recommendDn(flowM3hVal: number): DnInner {
  for (const row of DN_INNER) {
    if (velocity(flowM3hVal, row.innerMm) <= VELOCITY_MAX) return row;
  }
  return DN_INNER[DN_INNER.length - 1]!;
}
